import { useCallback, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { CurrentUserOrganizationDto } from '@sib/api';
import { SearchParam } from '../types';

const isOrganizationObject = (
  object: unknown
): object is CurrentUserOrganizationDto =>
  typeof object === 'object' && !!object && 'id' in object && 'name' in object;

export const useOrganizationFromSearch = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [organization, setOrganization] =
    useState<CurrentUserOrganizationDto | null>(null);

  const getOrganizationFromSearch = useCallback(() => {
    const organizationParam = searchParams.get(SearchParam.Organization) || '';

    if (!organizationParam) return null;

    try {
      const organizationObject = JSON.parse(atob(organizationParam));
      const organization = isOrganizationObject(organizationObject)
        ? organizationObject
        : null;

      const newParams = new URLSearchParams(searchParams);
      newParams.delete(SearchParam.Organization);
      setSearchParams(newParams);

      setOrganization(organization);
    } catch (e) {
      console.error('Invalid organization query parameter', e);

      return null;
    }
  }, [searchParams, setSearchParams]);

  useEffect(() => {
    getOrganizationFromSearch();
  }, [getOrganizationFromSearch]);

  return organization;
};
